import type { ReactNode } from "react";

interface KpiChartCardProps {
  title: ReactNode;
  subtitle: ReactNode;
  legend?: ReactNode;
  children: ReactNode;
}

/** Shared frame for the dashboard KPI charts: card, title block, legend slot. */
export function KpiChartCard({ title, subtitle, legend, children }: KpiChartCardProps) {
  return (
    <div className="rounded-[14px] border bg-card p-[21px]">
      <div className="mb-3 flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[15px] font-medium text-foreground">{title}</p>
          <p className="text-[12px] text-muted-foreground">{subtitle}</p>
        </div>
        {legend}
      </div>
      {children}
    </div>
  );
}
